import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop, Inject } from 'vue-property-decorator';
import { Popover, PopoverPlacement, PopoverTrigger } from '../popover/popover';
import { AlertType } from '../alert/alert'
import { Icon } from '../icon/icon';

@Component({
    template: require('./modal.html'),
    name: 'wc-modal',
    components: {
        'wc-icon': Icon
    }
})

export class Modal extends Vue {
    @Inject()
    $validator;
    @Prop()
    type: AlertType;
    @Prop()
    onSelectingOk: () => void;
    @Prop()
    onSelectingCancel: () => void;
    @Prop()
    onOutsideClick: () => void;
    @Prop()
    header: string;
    @Prop()
    body: string;
    @Prop()
    footer: string;
    @Prop()
    okText: string;
    @Prop()
    cancelText: string;
    @Prop({
        default: "520px"
    })
    formWidth: string;
    @Prop({
        default: true
    })
    canClose: boolean;

    OnConfirm() {
        this.showModal = false;
        this.onSelectingOk.call(this);
    }

    OnCancel() {
        this.showModal = false;
        this.onSelectingCancel.call(this);
    }

    OnMouseout() {
        // this.showModal = false;
        // this.onOutsideClick.call(this);
    }

    OnModalClick(e: Event) {
        // e.stopPropagation();
    }

    get iconName() {
        switch (this.type) {
            case AlertType.success: return 'checkcircleo';
            case AlertType.info: return 'infocircleo';
            case AlertType.warning: return 'exclamationcircleo';
            case AlertType.error: return 'closecircleo';
            case AlertType.question: return 'questioncircleo';
            default: return '';
        }
    }

    get className() {
        let className = `wc-modal ${this.type ? this.type : ''}`;
        return className;
    }
    showModal = true;
}



// WEBPACK FOOTER //
// node_modules/wc-lib/src/wc-ui/components/modal/modal.ts